// extracted by mini-css-extract-plugin
module.exports = {"sectionRow":"f8a9KEsJ","titleBase":"YYqnfLhn","chartWrapper":"p0SdDUCs","headerWrapper":"JUbT_B8m","fullscreenButtonContainer":"uHg3AmlI"};